import { useTranslation } from "react-i18next";
import { TableHead, cn } from "ui";

import { SET_HEAD_CELL } from "src/workouts/workoutSetCells";

export function LogHeadCell() {
  const { t } = useTranslation();

  return (
    <TableHead className={cn(SET_HEAD_CELL, "w-6")}>
      {t("workoutItem.done")}
    </TableHead>
  );
}
